import { useEffect, useState } from "react";
import Select from "react-select";

type DataPickerProps = {
  onChange: (items: any) => void;
  items: any;
  values: any;
  isMulti?: boolean;
  placeholder?: string;
};

const DataPicker = (props: DataPickerProps) => {
  const { onChange, values, items = [], placeholder, isMulti = true } = props;
  const defaultItem = isMulti ? [] : {};
  const [selectedOptions, setSelectedOptions] = useState<any>(values || defaultItem);
  const [listOptions, setListOptions] = useState<any>(items);

  useEffect(() => {
    setListOptions(items);
  }, [items]);

  useEffect(() => {
    setSelectedOptions(values);
  }, [values]);

  return (
    <>
      <Select
        isMulti={isMulti}
        options={listOptions}
        value={selectedOptions}
        className="basic-multi-select"
        classNamePrefix={placeholder}
        onChange={(newValue) => {
          onChange(newValue);
        }}
      />
    </>
  );
};

export default DataPicker;
